import React, { useState } from 'react';

import './styles.scss';

const SearchFormFilter = ({onChange}) => {
    const [state, setState] = useState({
        virus: false,
        documents: false,
        patients: false
	});
	
	const handleChangeInput = ({target}) => {
        for(let key in state) {
            state[key] = false;
        };

        setState({...state, [target.id]:target.checked});
        onChange({...state, [target.id]:target.checked});
    };
    
	return (
		<div className="search-form__filter">
			<p className="search-form__filter-title">Filter by:</p>
			<ul className="search-form__filter-panel list-reset">
				<li className="search-form__filter-item">
					<label>
						<input 
							id="virus"
							type="radio" 
							name="product-color" 
							value="red" 
                            onChange={handleChangeInput}
						/>
						<span className="red">Virus</span>
					</label>
				</li>
				<li className="search-form__filter-item">
					<label className="label__check">
						<input 
							id="documents"
							type="radio" 
							name="product-color" 
                            value="blue" 
                            onChange={handleChangeInput}
						/>
						<span className="blue">Documents</span>
					</label>
				</li>
				<li className="search-form__filter-item">
					<label>
						<input 
							id="patients"
							type="radio" 
							name="product-color" 
                            value="black" 
                            onChange={handleChangeInput}
						/>
						<span className="black">Patients</span>
					</label>
				</li>
			</ul>
		</div>
	);
};

export default SearchFormFilter;
